<template>
    <div id="contendor-principal-menus" class="container-fluid">
        <div id="encabezados">
            <h1>ADMINISTRACIÓN DE MENUS</h1>
            <h4>Agrega, modifica o da de baja los menús de los Micrositios</h4>
        </div>
        <!-- SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <transition name="fade">
            <div class="seccion-filtrosDeBusqueda mt-4" v-show="!ocultarFiltros">
                <div class="titulo-contendor">
                    <div class="form-inline justify-content-between">
                        <h4>Filtros de búsqueda</h4>
                        <!-- <button v-if="submenus.actualizacionDeFiltros.actualizar" @click="submenus.actualizacionDeFiltros.actualizar = false, submenus.actualizacionDeFiltros.contRender += 1" type="button" class="btn btn-sm btn-light"><i class="fas fa-sync-alt"></i></button> -->
                    </div>
                </div>
                <CFiltrosDeBusqueda
                    :ID_COMPONENTE="C_FILTROS_BUSQUEDA_ID"
                    class="contenedor-gris"
                    v-on:RealizarBusquedaDeMenus="evtBusquedaMenus"></CFiltrosDeBusqueda>
            </div>
        </transition>
        <!-- FIN SECCION PARA LOS FILTROS DE BUSQUEDA -->
        <!-- SECCION CRUD PARA MENUS -->
        <div id="seccion-crud" class="mt-4">
            <div class="titulo-tabla">
                <div class="row">
                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-2 pt-1"><h4>Administración de Menús</h4></div>
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1 d-flex justify-content-end">
                        <div class="d-flex">
                            <button v-if="menus.BD.length > 1" type="button" class="mr-2 btn btn-light" data-toggle="modal" data-target="#modal-ordenamiento-menus"><i class="fas fa-sort-numeric-up"></i></button>
                            <button type="button" @click="evtMostrarFormulario" class="btn btn btn-light mr-4"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="tabla-menus-SICPO-VADM" class="contenedor-gris table-responsive" >
                <div v-if="menus.seleccionados.length > 1" id="accion-estatus-submenus" class="form-inline justify-content-end">
                    <h6 @click="evtMostrarModalCambioEstatus" class="mr-3"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar estatus</h6>
                </div>
                <table 
                    class="table table-striped table-light table-hover"
                    id="tabla-menus"              
                    data-toggle="table"
                    data-pagination="true"
                    data-undefined-text="Sin información"
                    
                    data-page-size = "5"
                    data-page-list="[5,10,20]"
                    data-click-to-select="false"
                    data-search="true"
                    
                    >
                    <thead class="thead-green">
                        <tr>
                            
                            <th data-halign="center" data-width="10" data-align="center" data-field="MenuId" data-sortable="true">
                                Folio
                            </th>
                            <!-- <th data-halign="center" data-width="25" data-align="center" data-field="TipoPosicion.Nombre" data-sortable="true">
                               Tipo De Menu
                            </th> -->
                            <th data-halign="center" data-width="25" data-align="center" data-field="PosicionMenu" data-sortable="true">
                               Tipo De Menu
                            </th>
                            <!-- <th data-halign="center" data-width="20" data-align="center" data-field="Menu.Titulo" data-sortable="true">
                                Menu
                            </th> -->
                            <th data-halign="center" data-width="30" data-align="center" data-field="Titulo" data-sortable="true">
                                Titulo
                            </th>
                            <!-- <th data-halign="center" data-width="20" data-align="center" data-field="SubmenuAlQuePertenezco.Titulo" data-sortable="true">
                                Submenu al que pertenece
                            </th> -->
                            <th data-events="operateEvents" id="switch-contenido-activo" data-width="10" data-field="EstaActivo.html" data-halign="center" data-align="center">
                                Activo
                            </th>
                            <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAcciones()" data-halign="center" data-align="center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                </table>
               
            </div>

  <div id="formulario-menu" class="contenedor-gris" v-if="mostrarFormularioMenu">
                <CFormularioEdicionMenu  :menuMicrositio="menuMicrositio" v-on:OcultarFormulario="evtOcultarFormulario"  :key="MenuMicrositioId"></CFormularioEdicionMenu>
                </div>


                   <!-- MODAL PARA ORDENAMIENTO -->

 <div id="modal-ordenamiento-menus" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static" >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
          <div class="modal-header">
                        <h5 class="modal-title">Ordenamiento de menús</h5>
                        <button  id="btn-cerrar-modal-ordenamiento-menus" class="close" data-dismiss="modal" @click="cancelaOrdenamiento()"><i class="fas fa-times-circle"></i></button> 
                           
        </div> 
     <div id="lista-ordenamiento-menus" class="mt-2">
      <ClistaOrdenable :elementos="this.menus.BD"
      :referenciasElemento=" {folio: 'MenuId', orden: 'OrdenDelMenu',fechaPublicacion: 'fp', descripcion: 'Titulo' }"
      :informacionAmostrar="{ folio: true, fechaPublicacion: false, descripcion: true }"
       v-on:ModificacionEnListaDeElementos="evtOrdenDeMenusSeModifico" :key="keyOrden">
      </ClistaOrdenable>
      </div> 
        <div class="d-flex justify-content-end mt-3 mb-3">
          <button class="btn btn-sm btn-light mr-3"  @click="OrfenAlfabetico()"><i class="fas fa-sort-alpha-down"></i>&nbsp;&nbsp;Ordenar Alfabeticamente</button>
          <button class="btn btn-sm btn-light mr-3"  @click="CambioOrdenMenus()"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
    
      </div> 
     </div>
  </div>
</div> 
        <!-- MODAL CONFIRMACION -->

  

</div>
    </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
import axios from 'axios'
  import api from '@/../static/js/api'
  import Datepicker from 'vuejs-datepicker';
import CFiltrosDeBusqueda from '@/components/SICPO/Micrositios/Menu/CFiltrosDeBusquedaMenusMicrositios.vue';
  import C001PaginaInicio from '@/components/SICPO/Catalogos/C001PaginaInicio.vue'
   import CFormularioEdicionMenu from '@/components/SICPO/Micrositios/Menu/CFormularioEdicionMenu.vue'
   import ClistaOrdenable from '@/components/SICPO/Comun/ClistaOrdenable.vue'

export default {
    components: {
        C005TiposPosicion: catalogos.SICPO.C005TiposPosicion,
        CFiltrosDeBusqueda,
        C001PaginaInicio,
        Datepicker,
        CFormularioEdicionMenu,
        ClistaOrdenable
    },
    data() {
        return {
            keyOrden:1,
            mostrarFormularioMenu:false,
            mostrarTablaMenus:true,
            menuMicrositio:null,
            MenuMicrositioId:0,
              fechaDatePickerInicio: new Date(),
            fechaDatePickerfinal: new Date(),
            fechaSeleccionada: 0,
            fechaDefaultDtPkInicio: new Date(),
            fechaDefaultDtPkFinal: new Date(),
            DatePickerFormato: 'yyyy-MM-dd',
            languaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
            enumeraciones,
            C_FILTROS_BUSQUEDA_ID: 'FB_AdmistracionMenusPW',
            ocultarFiltros: false,
            menus: {
                filtrosDeBusqueda: null,
                BD: [],
                memoria: [],
                seleccionado: null,
                seleccionados: []
            },

        
        }
    },
    methods: {
        cancelaOrdenamiento:function(){
           this.obtenerMenusMicrositios()
        },
          evtOrdenDeMenusSeModifico: function(editado, listaDeMenus) {
            this.menus.BD = listaDeMenus;
        },
        OrfenAlfabetico:function(){
            let field='Titulo';
 this.menus.BD.sort((a, b) => (a[field] || "").toString().localeCompare((b[field] || "").toString()))
this.keyOrden += 1;
 

        },
 CambioOrdenMenus: async function() {     
                    const MENUS_NUEVO_ORDEN = await Promise.resolve(this.actualizarOrdenEnListaDeMenus());
                    if(MENUS_NUEVO_ORDEN.length > 0) {
                         const PETICION = { Menus: MENUS_NUEVO_ORDEN, esPrueba: false };
                         $("#modal-ordenamiento-menus").modal('hide');
                         await Promise.resolve(this.modificarOrdenamientoMenusBD(PETICION));
                    }

            
        },

        actualizarOrdenEnListaDeMenus: async function() {
            let listaOrdenada = [];
            if(this.menus.BD.length > 0) {
                let orden = 1;
                listaOrdenada = this.menus.BD.map(m => {
                    let menuObj = { 
                        MenuId: m.MenuId, 
                        EsDescarga: false,
                        Activo: false,
                        OrdenDelMenu: orden,
                        EsMenuEspecial: false,
                        ElMenuParpadea: false
                    };
                    orden ++;
                    return menuObj;
                });
            }
            return listaOrdenada;
        },


        modificarOrdenamientoMenusBD: async function(peticionAPI) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR =  api.SICPO.sistema.paginaweb.administracionDeMenus.ModificarOrdenamientoDeMenusPW
                //    : api.SICPO.sistema.paginaweb.administracionDeMenus.OrdenarAlfabeticamenteMenusPW;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_MODIFICAR_MENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_MODIFICAR_MENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-ordenamiento-menus").modal('show');
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    const ES_PARA_ACTUALIZAR = true;
                   this.obtenerMenusMicrositios();
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },


        evtMostrarFormulario: function() {
            let menu={}
            menu.PaginaDeInicio = null;
            menu.EsNuevo = true;
            let TipoPosicion={ TipoPosicionId:null};          
            menu.TipoPosicion=TipoPosicion;
            this.mostrarFormularioMenu=true;
            this.menuMicrositio = menu
            this.MenuMicrositioId=0;
            $("#tabla-menus-SICPO-VADM").hide();


        },
        evtBusquedaMenus: function(parametrsoDeBusqueda) {
            this.menus.filtrosDeBusqueda = parametrsoDeBusqueda;
             this.mostrarFormularioMenu = false;
            $("#tabla-menus-SICPO-VADM").show();
           this.obtenerMenusMicrositios();
        },
        obtenerMenusMicrositios:function(){
              comun.SeEstaCargandoInformacion(true);
                //this.generarListadoConNuevoOrden();
                               
                 const parametros = {}
                 parametros.PaginaId =this.menus.filtrosDeBusqueda.paginaId;
                 parametros.PosicionId = this.menus.filtrosDeBusqueda.posicionId;
                 parametros.EsDescarga = this.menus.filtrosDeBusqueda.conDescarga;
                 parametros.Titulo = this.menus.filtrosDeBusqueda.tituloFiltro;
                 parametros.SoloActivos = this.menus.filtrosDeBusqueda.soloActivos;
                 parametros.SoloCancelados = this.menus.filtrosDeBusqueda.soloCancelados;
                 parametros.EsPrueba = false;

                
                 const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.administracionDeMenus.ObtenerMenusPW;  
                 //'SICPO/AdministracionDeMenusPW/ObtenerMenus';

                 axios.post(api.conexion + METODO_API_AGREGAR,parametros,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
                     comun.SeEstaCargandoInformacion(false);
                     if (respuesta.data.SiHayError) {
                         console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                     } 
                     else {         
                        //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        this.menus.BD = respuesta.data.Menus;
                          this.$nextTick(async () => {
                          await Promise.resolve( this.llenarTablaDeMenus(respuesta.data.Menus));
                       await Promise.resolve(this.persistirSwitchMenusActivos(respuesta.data.Menus))
                       });
                        //   $("#tabla-menus").bootstrapTable({  data: respuesta.data.Menus });      
                        //   $("#tabla-menus").bootstrapTable('load',  respuesta.data.Menus); 
                     }
                 }).catch(excepcion => {
                     comun.SeEstaCargandoInformacion(false);
                     console.log(excepcion);
                     comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                 });
        },
         darFormatoAMenus: async function(menus) {
            const ESTATUS_MENU = true;
            this.menus.Menus = menus.map(c => {
                let menuConFormato = c;
               menuConFormato.PosicionMenu = (c.TipoPosicion.TipoPosicionId==1)?"MENU PRINCIPAL":"SITIOS DE INTERES";
                menuConFormato.EstaActivo = {
                    activo: (c.Activo == ESTATUS_MENU),
                    html: `<label id="switch-activo-inactivo-MIC-${ c.MenuId }" class="switch-contenido-activo-MIC">
                            <input id="check-contenido-activo-MIC-${ c.MenuId }" type="checkbox">
                            <div id="slider-activo-inactivo-MIC-${ c.MenuId }" class="slider-contenido-activo-MIC"></div>
                           </label>`
                };
                return menuConFormato;
            });
        },
        
        llenarTablaDeMenus: async function(elementos) {
         
          await Promise.resolve(this.darFormatoAMenus(elementos));
          $("#tabla-menus").bootstrapTable({data: elementos });
          $("#tabla-menus").bootstrapTable('load', elementos);
         
            $('#tabla-menus').on('page-change.bs.table', (size, number) => {
                //console.log('entro::evento::');
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchMenusActivos(elementos));
                });
            });

          $("td[id^=switch-activo-inactivo-MIC]").addClass('switch-contenido-activo-MIC');
          $("td[id^=slider-activo-inactivo-MIC]").addClass('slider-contenido-activo-MIC');

        },
        agregarDetalleDeMenu:async function(i,r,d){
               $('#tabla-menus').children().last().children()[0].html('<table></table>').find('table').bootstrapTable({data:d.Submenus})
        },
       
         persistirSwitchMenusActivos: async function(menus) {
            if(menus.length > 0) {
                menus.forEach(cObj => {
                    const ID_SWITCH_ACTIVO_CONTENIDO = `check-contenido-activo-MIC-${ cObj.MenuId }`;
                    $("#" + ID_SWITCH_ACTIVO_CONTENIDO).prop('checked',  cObj.EstaActivo.activo);
                });
            }
        },
     
        evtCambiarEstatusDeMenu: function(menuSeleccionado) {
             comun.SeEstaCargandoInformacion(true);
                //this.generarListadoConNuevoOrden();
                               
                 const parametros = {}
                 const menu = {
                 MenuId : menuSeleccionado.MenuId,
                 Activo :!menuSeleccionado.Activo,
                 PaginaDeInicioId :this.menus.filtrosDeBusqueda.paginaId,
                 EsMenuEspecial : false,
                 TipoPosicion:{
                     TipoPosicionId: this.menus.filtrosDeBusqueda.posicionId,
                 },
                 EsPrueba : false,
                 }
                 parametros.Menus = [menu];

                
                 const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.administracionDeMenus.CambiarEstatusDeMenusPW;   
                  //'SICPO/AdministracionDeMenusPW/CambiarEstatusDeMenus';

                 axios.post(api.conexion + METODO_API_AGREGAR,parametros,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
                     comun.SeEstaCargandoInformacion(false);
                     if (respuesta.data.SiHayError) {
                         console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                     } 
                     else {
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        this.obtenerMenusMicrositios();
                     }
                 }).catch(excepcion => {
                     comun.SeEstaCargandoInformacion(false);
                     console.log(excepcion);
                     comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                 });

        },
        evtOcultarFormulario(opciones){
    this.mostrarFormularioMenu=opciones.ocultarFormulario;
   if(opciones.esEdicion) this.obtenerMenusMicrositios()
   $("#tabla-menus-SICPO-VADM").show();
  
},

        editarMenuMicrositio:function(menu){
                menu.PaginaDeInicio = this.menus.filtrosDeBusqueda.paginaId;
                this.menuMicrositio = menu;
                this.MenuMicrositioId = menu.MenuId;
        },
        formateadorHTMLAcciones: () => {
            return `<div>
                        <button id="editar-submenu-pw-SICPO" type="button" class="btn btn-sm btn-xs btn btn-info texto-ajustable align-middle align-center"><i class="fas fa-edit"></i>&nbsp;Editar</button>
                    </div>`;
        },
    },
    computed: {

    },
    mounted() {
        this.$nextTick(() => {
            $("#tabla-menus").bootstrapTable({  data: this.menus.BD });      
            $("#tabla-menus").bootstrapTable('load',  this.menus.BD); 
        });
        window.operateEvents = {
            "click #editar-submenu-pw-SICPO": (e,val,row,index) => {          
                this.mostrarFormularioMenu=true;
               $("#tabla-menus-SICPO-VADM").hide();
                this.editarMenuMicrositio(row);


            },
            "click #eliminar-contenido-pw-SICPO": (e,val,row,index) => {          
                //this.evtEliminarContenido(row)
            },
            "click #eliminar-archivo-pw-SICPO": (e,val,row,index) => {          
                /* $("#tabla-archivos-contenido").bootstrapTable('remove', {
                    field: 'RutaDelArchivo',
                    values: [row.RutaDelArchivo]
                });
                this.formulario.archivos.identificadoresDeArchivos = this.formulario.archivos.identificadoresDeArchivos.filter(ia => ia.llave != row.RutaDelArchivo);
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                }); */
                /* console.log('archivos::',this.formulario.archivos.lista);
                console.log('identificadores::',this.formulario.archivos.identificadoresDeArchivos); */
            },
            "click #descargar-archivo-SICPO": (e,val,row,index) => {   
                /* if(row.ArchivoDeContenidoDeLaPaginaWebId > 0)       
                    this.evtDescargarArchivo(row.RutaDelArchivo)
                else
                    this.evtDescargarArchivoEnMemoria(row); */
            },
           'click :checkbox': (e, value, row, index) => {
        this.evtCambiarEstatusDeMenu(row);
       // row.EsArchivoDeContenido=false;
      //row.EsContenido=true;
     //  this.confirmarCanceladoDeContenido(row,index);
               // this.evtCambiarEstatusConetenidoIndividual(e,row);
            },
            'click .icono-ampliar-texto': (e, value, row, index) => {
               // this.mostrarTextoDeContenidoCompleto(row, index);
            },
        };
    },
    created() {
      
    },
}
</script>
<style scoped>
.form-inline h4 {
    color: white;
}

.thead-green{
    background-color: var(--verde-pj-100);
}

#lista-ordenamiento-menus {
    border: 2px solid rgb(51, 49, 49);
    max-height: 70vh;
    overflow: auto;
}
.contenedor-gris {
    background-color: var(--gris-pj-100);
    padding: 25px;
}

.titulo-contendor {
    background-color: var(--verde-pj);
    padding: 13px 13px 5px 23px;
}

.seccion-filtrosDeBusqueda {
    margin-top: 3.5em;
    
}

#tabla-menus-SICPO-VADM table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.titulo-tabla {
    background-color: var(--verde-pj);  
    padding: 13px 13px 13px 23px;
}
.titulo-tabla h4{
    color: white;
}
</style>

<style>
#tabla-menus-SICPO-VADM .search {
    width: 20rem;
}

#tabla-menus-SICPO-VADM .dropdown-toggle {
    width: 3.3rem;
}

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-menu-activo-VAM {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-menu-activo-VAM input {display:none;}

.slider-menu-activo-VAM {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-menu-activo-VAM:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-menu-activo-VAM input:checked + .slider-menu-activo-VAM {
  background-color: #2ab934;
}

.switch-menu-activo-VAM input:focus + .slider-menu-activo-VAM {
  box-shadow: 0 0 1px #2196F3;
}

.switch-menu-activo-VAM input:checked + .slider-menu-activo-VAM:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-menu-activo-VAM:after {
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-menu-activo-VAM input:checked + .slider-menu-activo-VAM:after {  
  content:'';
}
</style>

<style >
.switch-contenido-activo-MIC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-contenido-activo-MIC input {display:none;}

.slider-contenido-activo-MIC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-contenido-activo-MIC:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}

.switch-contenido-activo-MIC input:focus + .slider-contenido-activo-MIC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-contenido-activo-MIC:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:after
{  
  content:'';
}

/* dropdown tabla de contenidos */
#tabla-resultados-edicion-SICPO .search {
    width: 20rem;
}

#tabla-resultados-edicion-SICPO .dropdown-toggle {
    width: 3.3rem;
}

/* #tabla-resultados-edicion-SICPO .pagination > li > a {
    background-color: white;
    color: #121213;
}

#tabla-resultados-edicion-SICPO > li > a:focus,
#tabla-resultados-edicion-SICPO > li > a:hover,
#tabla-resultados-edicion-SICPO > li > span:focus,
#tabla-resultados-edicion-SICPO .pagination > li > span:hover
{
    color: #111011;
    background-color: #eee;
    border-color: #ddd;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a {
    color: white;
    background-color:  black;
    border: solid 1px #39373d;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a:hover {
    background-color:  black;
    border: solid 1px #39373d;
} */
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Menu/CAdministradorDeMenusMicrositios.vue